<script setup lang="ts">
  import { computed, defineProps } from 'vue';

  const props = defineProps({
    title: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  });

  const isDisabled = computed(() => props.disable || props.loading);
</script>

<template>
  <button
    @click="handleClick"
    :disabled="isDisabled"
    :class="{
      'bg-gray-800': isDisabled,
    }"
    class="w-full py-3 flex items-center justify-center bg-teal-950 text-white text-center text-lg font-medium rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-600"
  >
    <!-- Лоадер -->
    <svg
      v-if="loading"
      class="animate-spin h-5 w-5 text-white mr-2"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      ></path>
    </svg>

    <!-- Текст кнопки -->
    {{ loading ? 'Loading...' : title }}
  </button>
</template>
